<template>
  <div class="absolute inset-0 pointer-events-none">
    <template v-for="item in lightsWithPositions" :key="`light-${item.light.id}`">
      <!-- Light Pip on 1D slider -->
      <div
        class="absolute pointer-events-auto cursor-pointer transition-transform"
        :class="{
          'scale-125 z-10': isSelected(item.light)
        }"
        :style="{
          left: `${item.position.x * 100}%`,
          top: '50%',
          transform: 'translate(-50%, -50%)'
        }"
        @mousedown.stop="emit('pipMouseDown', $event, item.light)"
        @click.stop="emit('pipClick', item.light)"
      >
        <!-- Pip circle -->
        <div
          class="w-5 h-5 rounded-full border-2 shadow-lg transition-all"
          :class="{
            'border-primary ring-2 ring-primary/50': isSelected(item.light),
            'border-white': !isSelected(item.light),
            'border-orange-400': item.isInherited
          }"
          :style="{ backgroundColor: getPipColor(item.light) }"
        >
          <!-- Inherited indicator dot -->
          <div
            v-if="item.isInherited"
            class="absolute -top-1 -right-1 w-2 h-2 rounded-full bg-orange-400 border border-background"
          />
        </div>
        
        <!-- Light name tooltip on hover -->
        <div
          class="absolute -bottom-6 left-1/2 -translate-x-1/2 whitespace-nowrap text-xs text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity"
        >
          {{ item.light.name }}
        </div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { ctToRGB } from '@/lib/colorConversion'
import type { Light } from '@/stores/lights'

interface LightWithPosition {
  light: Light
  position: { x: number }  // x is 0-1 representing position along slider
  isInherited?: boolean
  inheritedFrom?: string
}

interface Props {
  lightsWithPositions: LightWithPosition[]
  isSelected: (item: Light) => boolean
}

const props = defineProps<Props>()

const emit = defineEmits<{
  pipMouseDown: [event: MouseEvent, light: Light]
  pipClick: [light: Light]
}>()

// Get pip color based on CT value
function getPipColor(light: Light): string {
  const ct = light.current_state?.ct
  if (!ct) return '#ffffff'
  
  const rgb = ctToRGB(ct)
  return `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`
}
</script>
